import store from "@/store";

export default async (to, from, next) => {
  await store.dispatch("setCustomerCourses");
  await store.dispatch("setCustomers", { perPage: -1 });
  await store.dispatch("setCourseLookup");

  next();
};
